/*
 * hfd-tracking.js — форма «Где моя посылка» (sections/ds-hfd-tracking.liquid).
 *
 * Валидация полей на клиенте (та же нормализация, что на бэкенде:
 * израильский телефон в формате 0…, номер отправления 5–12 цифр), затем
 * POST {api}/hfd/track → {status: found|not_found|invalid|rate_limited|error}.
 * Найдено → ссылка на страницу статуса HFD и, если контейнер есть и экран
 * от 750px, та же страница в iframe (на телефонах — только ссылка). `?num=` в URL предзаполняет номер (ссылки из письма
 * об отправке и кабинета — H4/А′ в HFD_ROADMAP).
 *
 * Без JS форма уходит GET'ом на страницу поиска HFD (action формы) — здесь
 * это перехватывается. Инициализация идемпотентна (data-hfd-ready),
 * Theme Editor перерисовывает секцию — слушаем shopify:section:load.
 */

(function () {
  if (window.dsHfdTracking) return;
  window.dsHfdTracking = true;

  function normalizePhone(input) {
    var s = String(input || '').replace(/[^\d+]/g, '');
    if (s.charAt(0) === '+') s = s.slice(1);
    if (s.indexOf('00972') === 0) s = s.slice(5);
    else if (s.indexOf('972') === 0) s = s.slice(3);
    if (s.length === 9 && /^[1-9]/.test(s)) s = '0' + s;
    return /^0\d{8,9}$/.test(s) ? s : null;
  }

  function normalizeNum(input) {
    var s = String(input || '').replace(/\D/g, '');
    return /^\d{5,12}$/.test(s) ? s : null;
  }

  function initRoot(root) {
    if (root.hasAttribute('data-hfd-ready')) return;
    root.setAttribute('data-hfd-ready', '');

    var configNode = root.querySelector('[data-hfd-config]');
    var form = root.querySelector('[data-hfd-form]');
    if (!configNode || !form) return;
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (e) { return; }
    var labels = config.labels || {};
    var api = String(config.api || '').replace(/\/$/, '');

    var q = function (sel) { return root.querySelector(sel); };
    var ui = {
      num: q('[data-hfd-num]'),
      phone: q('[data-hfd-phone]'),
      submit: q('[data-hfd-submit]'),
      submitLabel: q('[data-hfd-submit-label]'),
      errNum: q('[data-hfd-error="num"]'),
      errPhone: q('[data-hfd-error="phone"]'),
      result: q('[data-hfd-result]'),
      found: q('[data-hfd-result-found]'),
      link: q('[data-hfd-result-link]'),
      notFound: q('[data-hfd-result-notfound]'),
      error: q('[data-hfd-result-error]'),
      embed: q('[data-hfd-embed]'),
      frame: q('[data-hfd-embed-frame]')
    };
    var busy = false;

    function showError(el, input, on) {
      if (el) el.hidden = !on;
      if (input) {
        input.setAttribute('aria-invalid', on ? 'true' : 'false');
        input.classList.toggle('track-form__input--invalid', on);
      }
    }

    function hideResults() {
      ui.result.hidden = true;
      ui.found.hidden = true;
      ui.notFound.hidden = true;
      ui.error.hidden = true;
      if (ui.embed) {
        ui.embed.hidden = true;
        if (ui.frame) ui.frame.removeAttribute('src');
      }
    }

    function show(box) {
      hideResults();
      ui.result.hidden = false;
      box.hidden = false;
      /* iframe — только на широких экранах: на телефонах чужая страница в
         iframe растягивается под содержимое и не прокручивается (iOS). */
      if (box === ui.found && ui.embed && ui.frame && window.matchMedia('(min-width: 750px)').matches) {
        ui.frame.src = ui.link.href;
        ui.embed.hidden = false;
      }
      if (!window.matchMedia('(min-width: 990px)').matches && ui.result.scrollIntoView) {
        ui.result.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    function setBusy(on) {
      busy = on;
      ui.submit.disabled = on;
      ui.submit.setAttribute('aria-busy', on ? 'true' : 'false');
      if (ui.submitLabel) ui.submitLabel.textContent = on ? (labels.checking || labels.submit) : labels.submit;
    }

    function track(num, phone) {
      setBusy(true);
      fetch(api + '/hfd/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ num: num, phone: phone })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data || {} }; });
      }).then(function (res) {
        setBusy(false);
        var data = res.data;
        if (data.status === 'found' && data.url) {
          ui.link.href = data.url;
          show(ui.found);
        } else if (data.status === 'not_found') {
          show(ui.notFound);
        } else if (data.status === 'invalid') {
          showError(data.field === 'phone' ? ui.errPhone : ui.errNum, data.field === 'phone' ? ui.phone : ui.num, true);
        } else {
          show(ui.error);
        }
      }).catch(function () {
        setBusy(false);
        show(ui.error);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var num = normalizeNum(ui.num.value);
      var phone = normalizePhone(ui.phone.value);
      showError(ui.errNum, ui.num, !num);
      showError(ui.errPhone, ui.phone, !phone);
      if (!num || !phone) {
        (!num ? ui.num : ui.phone).focus();
        return;
      }
      hideResults();
      track(num, phone);
    });

    [ui.num, ui.phone].forEach(function (input) {
      input.addEventListener('input', function () {
        showError(input === ui.num ? ui.errNum : ui.errPhone, input, false);
      });
    });

    /* Предзаполнение из ссылки письма/кабинета: ?num=95572452 */
    try {
      var fromUrl = new URL(window.location.href).searchParams.get('num');
      if (fromUrl && !ui.num.value) {
        ui.num.value = fromUrl.replace(/\D/g, '');
        if (ui.num.value) ui.phone.focus();
      }
    } catch (e) { /* старые браузеры */ }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hfd-tracking]'), initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
